import React, { useEffect, useState } from 'react'
import TextField from '../../elements/form/TextField'
import { useDispatch, useSelector } from 'react-redux';
import { CREATING_DOCUMENT_REQUEST, ERROR, SET_SUCCESS } from '../../../store/types';
import TextareaField from '../../elements/form/TextareaField';
import { clearCreatedDocumentRequest, createDocumentRequest } from '../../../store/actions/documentRequestActions';
import ModalActionButton from '../../elements/ModalActionButton';
import FileUpload from '../../elements/form/FileUpload';
import { authHeader } from '../../../utils';
import { Switch } from '@headlessui/react';

const NewDocumentRequest = ({description, itemType, item, closeFunction, reload}) => {
    const dispatch = useDispatch()
    const documentRequestsSelector = useSelector(state => state.documentRequests)
    const [documentRequest, setDocumentRequest] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        console.log('created rqst', documentRequestsSelector.createdDocumentRequest)
        if(documentRequestsSelector.createdDocumentRequest !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'document requested successfully'
            })
            dispatch(clearCreatedDocumentRequest())
            closeFunction()
            reload()
            setTimeout(() => {
                setDocumentRequest({})
                setValidationErrors({})
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentRequestsSelector.createdDocumentRequest, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!documentRequest.name || documentRequest.name === '') {
            errors.name = true
        }
        if(!documentRequest.description || documentRequest.description === '') {
            errors.description = true
        }
        if(requiresSample && !file) {
            errors.file = true
        }
        setValidationErrors(errors)

        return errors
    }

    const pushDocumentRequest = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }
            const payload = {
                ...documentRequest, 
                ...{
                    [itemType]: item._id,
            }}
            
            if(file) {
                const uploaded = await handleUpload(file) 
                payload.sampleDocumentUrl = uploaded.data.file
            }

            dispatch(createDocumentRequest(payload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const [requiresSample, setRequiresSample] = useState(false);

    const [file, setFile] = useState(null);

    const handleUpload = async (file) => {
        console.log(file)
  
        var formData = new FormData()
        formData.append('file', file.file )
        const headers = new Headers();
        headers.append("Authorization",  authHeader().Authorization);

  
        try {
            dispatch({
                type: CREATING_DOCUMENT_REQUEST,
                payload: true
            })
            const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
                method: "POST",
                headers,
                body: formData,
            });
            const response = await doUpload.json();
    
           return response
        } catch (error) {
            dispatch({
                type: ERROR,
                error,
            });
        }
    }

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>{description}</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Document name" 
                    fieldId="username" 
                    inputType="text" 
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setDocumentRequest({...documentRequest, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Document Description" 
                    fieldId="case-summary" 
                    inputType="text" 
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setDocumentRequest({...documentRequest, ...{description: value}})}}
                />
            </div>

            <div className="w-full flex justify-between gap-x-4 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Sample document required</label>
                    <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch if the request needs a sample, or if the document is a form that needs to be returned</label>
                </div>
                <div className='w-2/12 flex flex-row-reverse'>
                    <Switch
                        checked={requiresSample}
                        onChange={setRequiresSample}
                        className={`${
                            requiresSample ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">sample document required</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                requiresSample ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            {requiresSample && <div className='mt-2 w-full'>
                <FileUpload
                    hasError={validationErrors.file}
                    fieldLabel={`Sample document/form`}
                    returnFileDetails={(details)=>{
                        setFile(details)
                    }}
                    acceptedFormats={['pdf', 'jpeg', 'jpg']}
                />
                <label className='block mt-3 text-xs text-gray-400'>{`Sample file to be followed or returned`}</label>
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create document request`}
                    buttonAction={()=>{pushDocumentRequest()}}
                    processing={documentRequestsSelector.creatingDocumentRequest}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default NewDocumentRequest